module.exports = __webpack_public_path__ + "FixelDisplay-ExtraBoldItalic-49a2211609565d83310f4263ed35c75e.woff2";